import './globals.css'
import ReactDOM from 'react-dom/client'

import PageLayout from '@/components/PageLayout'
import displayMode from './displaymode.js'

window.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia(`(display-mode: ${displayMode})`).matches) {
    location.replace('/app')
  }
})

ReactDOM.createRoot(document.getElementById('slot') as HTMLElement).render(
  <PageLayout />
)
